export const convertUrlToImage = async (fileName, url) => {
  return await fetch(url)
    .then(async response => {
      const arr = url.split('.');
      const type = arr[arr.length - 1];
      const blob = await response.blob()
      const file = new File([blob], `${fileName}.${type}`, { type: `image/${type}` });
      return file;
    })
}